module.exports = __webpack_public_path__ + "img/collecting_vouchers.5169fd71.png";